// src/components/Legal/MarkdownPage.js

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

function MarkdownPage({ docName }) {
    const { i18n } = useTranslation();
    const [markdown, setMarkdown] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchMarkdown = async () => {
            setLoading(true);
            setError('');
            const lang = i18n.language || 'en'; // Default to 'en'
            const filePath = `/legal/${docName}_${lang}.md`;

            try {
                const response = await fetch(filePath);
                if (response.ok) {
                    const text = await response.text();
                    setMarkdown(text);
                } else {
                    // If language-specific file not found, try fetching the English fallback
                    console.warn(`File not found: ${filePath}. Falling back to English version.`);
                    const fallbackPath = `/legal/${docName}_en.md`;
                    const fallbackResponse = await fetch(fallbackPath);
                    if (fallbackResponse.ok) {
                        const text = await fallbackResponse.text();
                        setMarkdown(text);
                    } else {
                        throw new Error(`Fallback document '${docName}_en.md' also not found.`);
                    }
                }
            } catch (err) {
                console.error("Failed to load markdown file:", err);
                setError('Could not load the document. Please try again later.');
                setMarkdown(''); // Clear any previous content
            } finally {
                setLoading(false);
            }
        };

        fetchMarkdown();
    }, [docName, i18n.language]); // Re-fetch if docName or language changes

    if (loading) {
        return <div className="text-center text-white p-10">Loading...</div>;
    }

    if (error) {
        return <div className="text-center text-red-400 p-10">{error}</div>;
    }

    return (
        <div className="bg-brand-dark min-h-screen text-white py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto bg-brand-dark shadow-lg p-6 sm:p-8 border hover:border-brand-orange">
                {/* 
                  This 'prose' class is from Tailwind Typography plugin. 
                  If you don't use it, you'll need to style h1, p, ul, etc. manually.
                */}
                <article className="prose prose-invert lg:prose-xl">
                    <ReactMarkdown>{markdown}</ReactMarkdown>
                </article>
            </div>
        </div>
    );
}

export default MarkdownPage;